import { Card, Space, Spin, Table, Tag } from 'antd';
import { Link, useParams } from 'react-router-dom';

import MetaDecorator from 'apps/home/components/MetaDecorator';
import PageTitle from 'apps/home/components/PageTitle';
import apiCall from 'apps/futureflex/apiCalls/company';
import { useFetchApiGet } from 'hooks/api';
import { useEffect } from 'react';
import { investmentUnallocatedBalanceHistoryTypeColors } from 'utils/constants';
import { formatDate, formatDateTime } from 'utils/formatDate';

const unallocatedBalanceColums = [
  {
    title: 'Created At',
    dataIndex: 'created_at',
    render: value => formatDateTime(value),
  },
  {
    title: 'Updated At',
    dataIndex: 'updated_at',
    render: value => formatDateTime(value),
  },
  {
    title: 'Product Code',
    dataIndex: 'product_code',
    render: (value, record) => (
      <Link to={`/catalog/products/funds/${record.product_id}`}>
        {value}
      </Link>
    ),
  },
  {
    title: 'Balance',
    dataIndex: 'unallocated_quantity',
    align: 'right',
    render: value => new Intl.NumberFormat('en-US').format(value),
  },
];

const unallocatedHistoriesColumns = [
  {
    title: 'Date',
    dataIndex: 'date',
    render: value => formatDate(value),
  },
  {
    title: 'Created At',
    dataIndex: 'created_at',
    render: value => formatDateTime(value),
  },
  {
    title: 'Updated At',
    dataIndex: 'updated_at',
    render: value => formatDateTime(value),
  },
  {
    title: 'Product Code',
    dataIndex: 'product_code',
    render: (value, record) => (
      <Link to={`/catalog/products/funds/${record.product_id}`}>
        {value}
      </Link>
    ),
  },
  {
    title: 'Transfer Quantity',
    dataIndex: 'quantity',
    align: 'right',
    render: value => new Intl.NumberFormat('en-US').format(value),
  },
  {
    title: 'Transfer Type',
    dataIndex: 'type',
    align: 'left',
    render: type => {
      const label =
        type === 'in' ? 'Transfer' : type === 'out' ? 'Redistribute' : type;
      return (
        <Tag color={investmentUnallocatedBalanceHistoryTypeColors[type]}>
          {label}
        </Tag>
      );
    },
  },
  {
    title: 'Program Order',
    dataIndex: 'program_order_id',
    render: program_order_id => (
      <Link to={`/futureflex/program-orders/${program_order_id}`}>
        {program_order_id ? program_order_id : 'N/A'}
      </Link>
    ),
  },
];

const InvestmentCompanyRedistributionFund = () => {
  const params = useParams();

  const { data: companyData, isLoading: isLoadingCompany, load: loadCompany } = useFetchApiGet(
    apiCall.detail,
    { resourceName: 'data' }
  );
  const { data: balancesData, isLoading: isLoadingBalances, load: loadBalances } = useFetchApiGet(
    apiCall.balances,
    { resourceName: 'data' }
  );
  const { data: historyTxsData, isLoading: isLoadingHistory, load: loadHistory } = useFetchApiGet(
    apiCall.unallocatedHistory,
    { resourceName: 'data' }
  );

  useEffect(() => {
    if (params.company_id) {
      loadCompany({ id: params.company_id });
      loadBalances({ id: params.company_id });
      loadHistory({ id: params.company_id });
    }
  }, [params.company_id]);

  const isLoading = isLoadingCompany || isLoadingHistory || isLoadingBalances || (!companyData && !balancesData && !historyTxsData);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spin size="large" />
      </div>
    );
  }

  const company = companyData || {};
  const title = `Company Redistribution Fund - ${
    company.brand_name ? company.brand_name : ''
  }`;

  const { company_unallocated_balance } = balancesData || {};
  const historyTxs = historyTxsData;

  return (
    <>
      <MetaDecorator title={title} />
      <PageTitle title={title} />
      <Space direction="vertical" size={'large'}>
        <Card title="Redistribution Balances">
          <Table
            rowKey="id"
            columns={unallocatedBalanceColums}
            dataSource={company_unallocated_balance}
            pagination={false}
          />
        </Card>
        <Card title="Transfer History">
          <Table
            rowKey="id"
            columns={unallocatedHistoriesColumns}
            dataSource={historyTxs}
            pagination={true}
          />
        </Card>
      </Space>
    </>
  );
};

export default InvestmentCompanyRedistributionFund;
